module.exports = __webpack_public_path__ + "static/media/apple.4d3eb39e.svg";